<template>
  <v-main>
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-container fluid>
      <BalanceDetail is-merchant :equity="equity" :balanceLogList="logList" />
    </v-container>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import BalanceDetail from '@/components/BalanceDetail.vue'
import { homeStore } from '@/store/home'
import { customerStore } from '@/store/customer'
import { equityStore } from '@/store/equity'

export default {
  name: 'CustomerBalanceDetailPage',
  components: {
    AppbarBackIcon,
    BalanceDetail,
  },
  data() {
    return {
      balance_logs: [],
    }
  },
  computed: {
    customer_id() {
      return this.$route.query.customer || null
    },
    customer() {
      return customerStore.get(this.customer_id)
    },
    equity_id() {
      return this.$route.query.equity || null
    },
    equity() {
      return equityStore.get(this.equity_id)
    },
    title() {
      const custName = this.customer?.nickname || this.customer_id || ''
      const equityName = this.equity?.name ?? '详情'
      return `${custName} - ${equityName}`
    },
    logList() {
      return this.balance_logs || []
    },
  },
  async mounted() {
    await homeStore.doLoad()
    if (this.customer_id && !this.customer) {
      await customerStore.doInfo({
        customer_id: this.customer_id,
      })
    }
    if (this.equity_id && !this.equity) {
      await equityStore.doLoad()
    }
    let result = await customerStore.doQueryLog({
      equity_id: this.equity_id,
      customer_id: this.customer_id,
    })
    this.balance_logs = result.item_s
  },
  methods: {},
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.layout {
  max-width: 600px;
  margin: 0 auto;
  overflow: hidden;
}

.main {
  padding: 16px;
}
</style>
